jQuery( function ( $ ) {
    const hamburger = $( '#hamburger' );
    const closeBnt = $( '.js-close-drawer' );
    const sidebar = $( '.js-sidebar' );

    const ua = window.navigator.userAgent.toLowerCase();
    const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;
    const body = document.querySelector('body');

    hamburger.on( 'click', function() {
        let scrollPosition;
        sidebar.addClass( 'is-open' ).css( 'transition', 'transform .3s ease-in-out' );
        bodyFixedOn();
    } );
    closeBnt.on( 'click', function() {
        sidebar.removeClass( 'is-open' );
        setTimeout( function() {
            sidebar.css( 'transition', 'unset' );
        }, 300 );
        bodyFixedOff();
    } );

    $(window).on( 'resize', function() {
        let flag = '';
        if ( window.matchMedia( "(min-width: 600px)" ).matches && flag != 'pc') {
            flag = 'pc';
            bodyFixedOff();
        } else if ( window.matchMedia( "(max-width: 599px)" ).matches && flag != 'sp') {
            flag = 'sp';
            bodyFixedOff();
        }
    } );

    function bodyFixedOn() {
        if ( isiOS ){
            scrollPosition = window.pageYOffset;
            body.style.position = 'fixed';
            body.style.top = `-${scrollPosition}px`;
        } else {
            body.style.overflow = 'hidden';
        }
    }

    function bodyFixedOff() {
        if ( isiOS ) {
            body.style.removeProperty( 'position' );
            body.style.removeProperty( 'top' );
            window.scrollTo( 0, scrollPosition );
        } else {
            body.style.removeProperty( 'overflow' );
        }
    }
} );